var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.35004,
    y: 6.77734,
    width: 2.9,
    height: 14.4444,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.69998,
    y: 6.77734,
    width: 2.9,
    height: 14.4444,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.75,
    y: 6.77734,
    width: 2.9,
    height: 14.4444,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.05,
    y: 6.77734,
    width: 4.35,
    height: 14.4444,
    rx: 2.175,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.85,
    y: 6.77734,
    width: 1.45,
    height: 14.4444,
    rx: 0.725,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 27L27 27C28.6569 27 30 25.6569 30 24V18.3333",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.333V23.9997C1 25.6565 2.34315 26.9997 4 26.9997H11.15",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.66699L30 4.00033C30 2.34347 28.6569 1.00033 27 1.00033L19.85 1.00033",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69998 1L3.99998 1C2.34313 1 0.999981 2.34314 0.999981 4L0.999981 9.66667",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeWhiteOutline);
export default __webpack_public_path__ + "static/media/qrCodeWhiteOutline.d453b444c19da2fac0c406d84b4d19b4.svg";
export { ForwardRef as ReactComponent };